export default "__VITE_ASSET__CQo0adJ8__"